"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import clsx from "clsx";
import type { ListItem } from "@/app/_lib/definition";

export function Divider() {
  return (
    <div className="border-t-1 border-t-[#e8e8e8] border-dashed mt-[18px] pt-[18px]"></div>
  );
}

type ItemProps = {
  id: string;
  text: string;
  pathname?: string;
  date?: string;
  css: {
    height: string; // 15/32 for other,  33/16 for home  35/16 form work,
    fontSize: string;
    lineHeight: string;
  };
};

type ListProps = Pick<ItemProps, "pathname" | "css"> & {
  list: object[];
  divide: boolean;
};

export function Item({ id, text, date, css, pathname = "" }: ItemProps) {
  const p = usePathname();
  const path = pathname || p;

  //   console.log(path, "path");
  //   console.log("PPPPPP", usePathname());

  return (
    <li
      //   className={`text-[${css.fontSize}] line-height-[${css.height}] text-[#333] flex items-center`}
      //   className={`text-[15px] line-height-[32px] text-[#333] flex items-center`}
      style={css}
      className={`text-[#333] flex items-center`}
      key={text}
    >
      <div className="w-[4px] h-[4px] bg-[url('/imgs/dot.gif')]"></div>
      <div className="w-full flex justify-between hover:text-[#c00]">
        <Link
          href={`${path}/${id}`}
          //   href={`/${id}`}
          target="_blank"
          title={text}
          className="ml-[12px] w-[0] grow whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {text}
        </Link>
        <span className="ml-[10px] text-[#959595]">
          {date?.replace("T", "").slice(0, 10)}
        </span>
      </div>
    </li>
  );
}

export function DetailList({
  list,
  divide = true,
  pathname,
  css = {
    lineHeight: "32px",
    height: "32px",
    fontSize: "15px",
  },
}: ListProps) {
  return (
    <ul>
      {list.map((item: any, index: number) => (
        <React.Fragment key={item.documentId}>
          <Item
            id={item.documentId}
            text={item.title}
            date={item.createdAt}
            css={css}
            pathname={pathname}
          ></Item>
          {(index + 1) % 6 == 0 && index + 1 != list.length && divide && (
            <Divider></Divider>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
}

export function ImageItem({ item, baseUrl }: { item: ListItem; baseUrl: string }) {
  const pathname = usePathname();
  const src = item.cover?.url
    ? `${baseUrl}${item.cover.url}`
    : "/imgs/review/5.jpg";

  console.log(pathname, "pathname312312313");
  console.log(item.cover, src, "src312312313");
  return (
    <li>
      <Link href={`${pathname}/${item.documentId}`} target="_blank">
        <div className="p-[10px] bg-[#f2f2f2]">
          <Image
            src={src}
            alt=""
            width={240}
            height={136}
            className="h-[136px]"
          ></Image>
        </div>
        <div className="w-[240px] h-[30px] mb-[24px] leading-[30px] text-center whitespace-nowrap overflow-hidden text-ellipsis">
          <span>{item.title}</span>
        </div>
      </Link>
    </li>
  );
}

export function PictureList({ list, baseUrl }: { list: ListItem[], baseUrl: string}) {
  //   console.log("BASE_URL", process.env.NEXT_PUBLIC_BASE_URL);
  console.log("ITEM", list?.[0]?.cover?.url);
  return (
    <ul className="list-none flex flex-wrap content-start min-h-[500px] gap-x-[40px]">
      {list.map((item: any) => (
        <ImageItem item={item} key={item.documentId} baseUrl={baseUrl}></ImageItem>
      ))}
    </ul>
  );
}

export function RichTextRenderer({
  content,
  className = "",
  download = false,
}: {
  content: string;
  className?: string;
  download?: boolean;
}) {
  const [linkList, setLinkList] = useState<string[]>([]);

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const links = doc.querySelectorAll("a");

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.tagName === "A") {
        event.preventDefault();
        const url = target.getAttribute("href");
        if (url) {
          // 创建一个隐藏的 <a> 标签并触发下载
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = url.split("/").pop() || "file"; // 设置下载文件名
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      }
    };

    Array.from(links).forEach((link) => {
      link.addEventListener("click", handleClick);
    });

    // 清理事件监听
    return () => {
      Array.from(links).forEach((link) => {
        link.removeEventListener("click", handleClick);
      });
    };
  }, []);

  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
  );
}

export function CategoryMenu({
  list,
  category,
}: {
  list: any[];
  category: string;
}) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  // bg-amber-200

  const handleClick = (name: string) => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    params.set("category", name);

    replace(`${pathname}?${params.toString()}`);
  };

  return (
    <ul className="flex flex-wrap gap-[12px] mb-[20px]">
      {list.map((item) => (
        <li key={item.name} onClick={() => handleClick(item.name)}>
          <button
            className={clsx(
              "px-[15px] rounded-full text-black cursor-pointer text-[14px]! h-[32px] border border-solid border-[#bbb] hover:text-white hover:bg-[#2479FF] hover:border-[#2479FF]",
              {
                "text-white bg-[#2479FF]": category == item.name,
              }
            )}
          >
            {item.name}
          </button>
        </li>
      ))}
    </ul>
  );
}
